export const textMap = {
    en: {
        fullCheckboxText: 'Insert full width table',
        customBtnText: 'Custom',
        confirmText: 'Confirm',
        cancelText: 'Cancel',
        rowText: 'Row',
        colText: 'Column',
        notPositiveNumberError: 'Please enter a positive integer',
        custom: 'Custom',
        clear: 'Clear',
        transparent: 'Transparent',
        perWidthInsufficient: 'The percentage width is insufficient. To complete the operation, the table needs to be converted to a fixed width. Do you want to continue?',

        InsertTop: 'Insert a row above',
        InsertRight: 'Insert a column right',
        InsertBottom: 'Insert a row below',
        InsertLeft: 'Insert a column Left',
        MergeCell: 'Merge Cell',
        SplitCell: 'Split Cell',
        DeleteRow: 'Delete Row',
        DeleteColumn: 'Delete Column',
        DeleteTable: 'Delete table',
        BackgroundColor: 'Set background color',
        BorderColor: 'Set border color',
        SwitchWidth: 'Switch table width',
        InsertCaption: 'Insert table caption',
        ToggleTdBetweenTh: 'Toggle td between th',
    },
    pt: {
        fullCheckboxText: 'Inserir tabela com largura total',
        customBtnText: 'Personalizar',
        confirmText: 'Confirmar',
        cancelText: 'Cancelar',
        rowText: 'Linha',
        colText: 'Coluna',
        notPositiveNumberError: 'Por favor, insira um número inteiro positivo',
        custom: 'Personalizado',
        clear: 'Limpar',
        transparent: 'Transparente',
        perWidthInsufficient: 'A largura percentual é insuficiente. Para concluir a operação, a tabela precisa ser convertida para largura fixa. Deseja continuar?',

        InsertTop: 'Inserir linha acima',
        InsertRight: 'Inserir coluna à direita',
        InsertBottom: 'Inserir linha abaixo',
        InsertLeft: 'Inserir coluna à esquerda',
        MergeCell: 'Mesclar células',
        SplitCell: 'Dividir célula',
        DeleteRow: 'Excluir linha',
        DeleteColumn: 'Excluir coluna',
        DeleteTable: 'Excluir tabela',
        BackgroundColor: 'Definir cor de fundo',
        BorderColor: 'Definir cor da borda',
        SwitchWidth: 'Alternar largura da tabela',
        InsertCaption: 'Inserir legenda da tabela',
        ToggleTdBetweenTh: 'Alternar entre td e th',
    },
    es: {
        fullCheckboxText: 'Insertar tabla de ancho completo',
        customBtnText: 'Personalizar',
        confirmText: 'Confirmar',
        cancelText: 'Cancelar',
        rowText: 'Fila',
        colText: 'Columna',
        notPositiveNumberError: 'Por favor, ingrese un número entero positivo',
        custom: 'Personalizado',
        clear: 'Limpiar',
        transparent: 'Transparente',
        perWidthInsufficient: 'El ancho porcentual es insuficiente. Para completar la operación, la tabla debe convertirse a ancho fijo. ¿Desea continuar?',

        InsertTop: 'Insertar fila arriba',
        InsertRight: 'Insertar columna a la derecha',
        InsertBottom: 'Insertar fila abajo',
        InsertLeft: 'Insertar columna a la izquierda',
        MergeCell: 'Combinar celdas',
        SplitCell: 'Dividir celda',
        DeleteRow: 'Eliminar fila',
        DeleteColumn: 'Eliminar columna',
        DeleteTable: 'Eliminar tabla',
        BackgroundColor: 'Establecer color de fondo',
        BorderColor: 'Establecer color de borde',
        SwitchWidth: 'Cambiar ancho de tabla',
        InsertCaption: 'Insertar título de tabla',
        ToggleTdBetweenTh: 'Alternar entre td y th',
    },
};